export default __webpack_public_path__ + "static/Herpes-d7edd26839a530d96afa54e117d23c7b.svg";